import { render } from "./DIY.vue?vue&type=template&id=70f28737&scoped=true"
import script from "./DIY.vue?vue&type=script&lang=js"
export * from "./DIY.vue?vue&type=script&lang=js"

import "./DIY.vue?vue&type=style&index=0&id=70f28737&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f28737"]])

export default __exports__